import './_foreground-projects.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function ForegroundProjects() {
    const foregroundProjects = document.querySelectorAll('.foreground-projects');

    if (foregroundProjects.length > 0) {
        foregroundProjects.forEach(item => {
            const cards = item.querySelectorAll('.card');
            cards.forEach(card => {
                const overtitle = card.querySelector('.overtitle') as HTMLElement;
                if (overtitle.innerHTML === '') {
                    card.classList.add('no-overtitle');
                }
            });

            function resize(_matches: any) {
                if (window.innerWidth < 768) {
                    const projectsCarousel = item.querySelectorAll('.mobile .views-element-container');
                    const swiperBtnNext = item.querySelector('.swiper-button-next') as HTMLElement;
                    const swiperBtnPrev = item.querySelector('.swiper-button-prev') as HTMLElement;
                    const pagination = item.querySelector('.swiper-pagination') as HTMLElement;

                    projectsCarousel.forEach((el: any, index: number) => {
                        const swiperWrapper = el.querySelector('.cactus_view_rows') as HTMLElement;
                        const slides = item.querySelectorAll('.swiper-slide');

                        el.classList.add('swiper');
                        el.classList.add(`${index}`);
                        swiperWrapper.classList.add('swiper-wrapper');

                        const swiper = new Swiper(el, {
                            modules: [Navigation, Pagination],
                            pagination: {
                                el: pagination,
                                clickable: true,
                            },
                            loop: slides.length > 1,
                            slidesPerView: 1.3,
                            navigation: {
                                nextEl: swiperBtnNext,
                                prevEl: swiperBtnPrev,
                                addIcons: false,
                            },
                            spaceBetween: 12,
                            on: {
                                afterInit: function () {
                                    const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
                                    bullets.forEach((bullet: any) => {
                                        bullet.setAttribute('tabindex', '0');
                                        bullet.addEventListener('keydown', (event: any) => {
                                            if (event.key === 'ArrowLeft') {
                                                event.preventDefault();
                                                swiper.slidePrev();
                                            } else if (event.key === 'ArrowRight') {
                                                event.preventDefault();
                                                swiper.slideNext();
                                            }
                                        });
                                    });
                                },
                                slideChange: function () {
                                    const currentSlide = pagination.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active') as HTMLDivElement;
                                    if (currentSlide) {
                                        currentSlide.focus();
                                    }
                                },
                            },
                        });

                        if (swiperBtnNext) {
                            swiperBtnNext.addEventListener('keypress', function (e) {
                                if (e.code === 'Enter') {
                                    swiper.slideNext();
                                }
                            });
                        }

                        if (swiperBtnPrev) {
                            swiperBtnPrev.addEventListener('keypress', function (e) {
                                if (e.code === 'Enter') {
                                    swiper.slidePrev();
                                }
                            });
                        }

                        swiper.init();
                    });
                }
            }

            const mediaQuery = window.matchMedia('(max-width: 768px)');

            mediaQuery.removeEventListener('change', function () {});
            mediaQuery.addEventListener('change', e => resize(e.matches));

            resize(mediaQuery.matches);
        });
    }
}
